import { IconButton } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.PasswordInput;

type Props = {
  isPlainText: boolean;
  onToggle: () => void;
  disabled?: boolean;
};

export const PasswordVisibilityToggle = ({
  isPlainText,
  onToggle,
  disabled = false,
}: Props) => {
  const { t } = useResource();

  const a11yLabel = isPlainText
    ? t(RESOURCES.HidePassword)
    : t(RESOURCES.ShowPassword);

  return (
    <IconButton
      edge="end"
      size="small"
      onClick={onToggle}
      disabled={disabled}
      aria-label={a11yLabel}
      sx={{
        opacity: 0.5,
        padding: 1,
        "&:hover": {
          backgroundColor: "action.hover",
        },
      }}
    >
      {isPlainText ? (
        <VisibilityOffOutlinedIcon fontSize="small" />
      ) : (
        <VisibilityOutlinedIcon fontSize="small" />
      )}
    </IconButton>
  );
};
